import { MATERIALS_ORDER_TOPIC } from '@/components/Tickets/materialsOrderSelection';

const GENERIC_CONFIRMATION_COPY = Object.freeze({
  question: '¿Quedó resuelto tu problema?',
  confirmLabel: 'Sí, quedó resuelto',
  rejectLabel: 'No quedó resuelto',
  reasonLabel: 'Cuéntanos por qué no quedó resuelto',
  reasonPlaceholder: 'Qué sigue pasando o qué faltó',
});

const MATERIALS_CONFIRMATION_COPY = Object.freeze({
  question: '¿Te llegaron los materiales?',
  confirmLabel: 'Confirmar que llegó',
  rejectLabel: 'No llegó o llegó incompleto',
  reasonLabel: 'Cuéntanos qué no llegó o qué faltó',
  reasonPlaceholder: 'Qué material faltó y cuántas unidades, o si no llegó nada',
});

export function confirmationCopyFor(topic) {
  return topic === MATERIALS_ORDER_TOPIC ? MATERIALS_CONFIRMATION_COPY : GENERIC_CONFIRMATION_COPY;
}
